import React from "react";
import {Columns, Heading, Modal, Section, Table} from "react-bulma-components";


export default function InfoModal({show, setShow}){

    return (
        <Modal
            show={show}
            closeOnBlur
            onClose={() => setShow(false)}
        >
            <Modal.Content>
                <Section style={{background: "white"}}>
                    <Columns>
                        <Columns.Column>
                            <Heading>Info</Heading>
                        </Columns.Column>
                    </Columns>
                    <Columns>
                        <Columns.Column>
                            <Table bordered>
                                <tr>
                                    <td className={"table-highlight-dark-red"}></td>
                                    <td>The difference in days between book in date and workshop date is equal to or more than the warning days set in Settings</td>
                                </tr>
                                <tr>
                                    <td className={"table-highlight-orange"}></td>
                                    <td>The difference in days between book in date and workshop date is equal to or more than the reminder days set in Settings</td>
                                </tr>
                                <tr>
                                    <td className={"table-highlight-green"}></td>
                                    <td>The vehicle has arrived</td>
                                </tr>
                            </Table>
                        </Columns.Column>
                    </Columns>
                </Section>
            </Modal.Content>
        </Modal>
    )

}